import { Injectable } from '@angular/core';
import { Subject, BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AccordionService {
  private hideSubmenu = new BehaviorSubject<boolean>(false);

  constructor() {}

  hideDocumentSubmenu(data) {
    this.hideSubmenu.next(data);
  }
  documentSubmenu(): Observable<any> {
    return this.hideSubmenu.asObservable();
  }
}
